/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';

export interface IPharmacyConsumer {
  id?: string;
  consumerName?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  taxCode?: string | null;
  drugLicenceNumber?: string | null;
  contactCode?: IContactDetails;
  consumer?: IPharmacy;
  supplier?: IPharmacy | null;
}

export const defaultValue: Readonly<IPharmacyConsumer> = {
  active: false,
};
